var L = /^image-([\da-f]+)-(\d+x\d+)-(\w+)$/,
  y = a => {
    let t = L.exec(a),
      [, r, e, n] = t != null ? t : [];
    if (!t || !r || !e || !n) throw new Error(`Could not parse image ID "${a}"`);
    let [o, m] = e.split("x").map(d => Number.parseInt(d, 10));
    if (Number.isNaN(o) || Number.isNaN(m) || !o || !m) throw new Error(`Invalid dimensions "${e}"`);
    return {
      assetId: r,
      dimensions: {
        height: m,
        width: o,
        aspectRatio: o / m
      },
      format: n
    };
  },
  S = a => {
    let t = a.lastIndexOf("-");
    return a.slice(6, t) + "." + a.slice(t + 1);
  };
var x = ({
    baseUrl: a,
    ...t
  }) => {
    let {
      metadata: r,
      ...e
    } = h({
      ...t,
      options: {
        includeMetadata: !0
      }
    });
    if (!r) throw new Error("Missing image output metadata");
    return {
      src: `${`${a}${S(t.id)}`}?${A(e)}`,
      width: r.outputDimensions.width,
      height: r.outputDimensions.height
    };
  },
  b = ({
    id: a,
    mode: t = "contain",
    width: r,
    height: e,
    hotspot: n,
    crop: o,
    baseUrl: m,
    ...d
  }) => {
    let {
        w: u,
        h: p
      } = h({
        id: a,
        mode: t,
        width: r,
        height: e,
        hotspot: n,
        crop: o
      }),
      g = `${m}${S(a)}`,
      c = O(u).map(s => {
        let i = Math.round(u * s),
          l = p && Math.round(p * s);
        if (s < 1 && i < 50) return null;
        let I = h({
          id: a,
          mode: t,
          width: i,
          height: l,
          hotspot: n,
          crop: o,
          ...d
        });
        return `${g}?${A(I)} ${I.w}w`;
      }).filter(s => !!s);
    return Array.from(new Set(c));
  },
  R = ({
    id: a,
    baseUrl: t
  }) => {
    let {
      assetId: r,
      dimensions: e,
      format: n
    } = y(a);
    return {
      src: `${t}${r}-${e.width}x${e.height}.${n}`,
      width: e.width,
      height: e.height
    };
  },
  O = a => a < 160 ? [.5, 1, 2] : a < 750 ? [.5, 1, 1.5, 2] : a < 1400 ? [.25, .5, .75, 1, 1.5, 2] : [.25, .5, .75, 1, 1.25, 1.5, 1.75, 2],
  h = ({
    id: a,
    mode: t = "contain",
    width: r,
    height: e,
    hotspot: n,
    crop: o,
    queryParams: m,
    options: {
      includeMetadata: d = !1
    } = {}
  }) => {
    let u = y(a).dimensions,
      {
        width: p,
        height: g,
        aspectRatio: c
      } = o ? T(u, o) : u;
    if (r || (e ? (r = Math.round(e * c), e = void 0) : r = Math.round(p / 2)), t === "cover" && (!r || !e || r / e === c) ? t = "contain" : t === "contain" && e && (r = Math.min(r, Math.round(e * c)), e = void 0), r > p || e && e > g) {
      let i = e ? r / e : c;
      i >= c ? (r = p, e = e && Math.round(r / i)) : (e = g, r = Math.round(e * i));
    }
    let s = {
      w: r,
      q: 75,
      ...m
    };
    if (s.fm || (s.auto = "format"), o && (s.rect = j(u, o)), t === "cover") {
      if (s.fit = "crop", e && (s.h = e), n) {
        let i = o ? n.x / (1 - o.left - o.right) : n.x,
          l = o ? n.y / (1 - o.top - o.bottom) : n.y;
        s["fp-x"] = Q(N(i, 0, 1), 3), s["fp-y"] = Q(N(l, 0, 1), 3);
      } else s.crop = "entropy";
    } else s.fit = "max";
    if (d) {
      let i = e || Math.round(r / c);
      s.metadata = {
        sourceDimensions: u,
        outputDimensions: {
          width: r,
          height: i,
          aspectRatio: r / i
        }
      };
    }
    return s;
  },
  N = (a, t, r) => Math.max(t, Math.min(r, a)),
  Q = (a, t) => Math.round(a * Math.pow(10, t)) / Math.pow(10, t),
  T = (a, t) => {
    if (t.left + t.right >= 1 || t.top + t.bottom >= 1) throw new Error(`Invalid crop: ${JSON.stringify(t)}; crop values must be less than 1`);
    let r = Math.round(a.width * (1 - t.left - t.right)),
      e = Math.round(a.height * (1 - t.top - t.bottom)),
      n = r / e;
    return {
      width: r,
      height: e,
      aspectRatio: n
    };
  },
  j = (a, t) => {
    let {
      width: r,
      height: e
    } = T(a, t);
    return [Math.round(t.left * a.width), Math.round(t.top * a.height), r, e].join(",");
  },
  A = a => new URLSearchParams(Object.entries(a).sort(([r], [e]) => r.localeCompare(e)).map(([r, e]) => [r, String(e)])).toString().replace(/%2C/g, ",");
import P, { useEffect as z, useRef as _, useState as K } from "react";
var w = ({
    as: a,
    preview: t,
    style: r,
    alt: e,
    ...n
  }) => {
    let [o, m] = K(!1),
      d = _(null),
      u = () => {
        m(!0);
      };
    z(() => {
      var g;
      (g = d.current) != null && g.complete && u();
    });
    let p = a || "img";
    return P.createElement(P.Fragment, null, !o && P.createElement(p, {
      alt: o ? "" : e,
      className: n.className,
      "data-lqip": !0,
      height: n.height,
      id: n.id,
      src: t,
      style: r,
      width: n.width
    }), P.createElement(p, {
      "data-loading": o ? null : !0,
      alt: o ? e : "",
      onLoad: u,
      ref: d,
      style: o ? r : {
        ...k,
        ...r
      },
      ...n
    }));
  },
  k = {
    height: "10px",
    width: "10px",
    position: "absolute",
    zIndex: -10,
    opacity: 0,
    pointerEvents: "none",
    userSelect: "none"
  };
import W from "react";
var B = ({
  as: a,
  baseUrl: t,
  projectId: r,
  dataset: e,
  id: n,
  hotspot: o,
  crop: m,
  width: d,
  height: u,
  mode: p = "contain",
  preview: g,
  htmlWidth: c,
  htmlHeight: s,
  htmlId: i,
  queryParams: l,
  ...I
}) => {
  var v, D;
  if (!n) throw new Error("Missing required `id` prop for <SanityImage>.");
  if (!t && (!r || !e)) throw new Error("Missing required `baseUrl` or `projectId` and `dataset` props for <SanityImage>.");
  t = t != null ? t : `https://cdn.sanity.io/images/${r}/${e}/`;
  let M = n.endsWith("-svg"),
    $ = g && !M ? w : a != null ? a : "img",
    f = {
      alt: (v = I.alt) != null ? v : "",
      loading: (D = I.loading) != null ? D : "lazy",
      id: i,
      ...I
    };
  if (M) return W.createElement($, {
    ...R({
      id: n,
      baseUrl: t
    }),
    ...f
  });
  let C = {
      baseUrl: t,
      id: n,
      crop: m,
      hotspot: o,
      width: d,
      height: u,
      mode: p,
      queryParams: l
    },
    {
      src: q,
      ...E
    } = x(C);
  return f.srcSet = b(C).join(", "), f.src = q, f.width = c != null ? c : E.width, f.height = s != null ? s : E.height, g && (f.as = a != null ? a : "img", f.preview = g), W.createElement($, {
    ...f
  });
};
export { w as ImageWithPreview, B as SanityImage, x as buildSrc, b as buildSrcSet, y as parseImageId };